import {
  AdProductDisplay,
  AdProductType,
  AdProductVideo,
  AdProductVideoInternal,
  AdProductVideoSelfService,
} from '@features/campaigns/shared/types/campaign';

export function isAdProductDisplayNonNull(data: AdProductDisplay | null): data is AdProductDisplay {
  return data !== null;
}

export function isAdProductVideoNonNull(data: AdProductVideo | null): data is AdProductVideo {
  return data !== null;
}

export function isAdProductVideoCreativeExistsInDB(data: AdProductVideo | null): data is AdProductVideo {
  return Boolean(data && data.creative);
}

export function isAdProductVideoInternal(data: AdProductVideo | null): data is AdProductVideoInternal {
  return Boolean(data && data.type === AdProductType.INTERNAL);
}

export function isAdProductVideoSelfService(data: AdProductVideo | null): data is AdProductVideoSelfService {
  return Boolean(data && data.type === AdProductType.SELF_SERVICE);
}
